module.exports = __webpack_public_path__ + "static/media/RTPM-Icon.fd520f14.png";